import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmActionModalComponent } from '../confirm-action-modal/confirm-action-modal.component';
import { FamilyRemoveFlowController } from '../../utils/family-remove.controller';

/**
 * "Remove member" pop-up of the Family Plan tab (CWS-1815). Presentational: the flow controller
 * owns the plate, the pick of the next primary and the request; this renders it.
 *
 * @selector app-family-remove-modal
 * @input flow - The remove flow of the host tab.
 */
@Component({
  selector: 'app-family-remove-modal',
  standalone: true,
  imports: [FormsModule, MatSelectModule, ConfirmActionModalComponent],
  templateUrl: './family-remove-modal.component.html',
  styleUrls: ['./family-remove-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FamilyRemoveModalComponent {
  @Input({ required: true }) flow!: FamilyRemoveFlowController;

  get plate(): string {
    return this.flow.member?.vehicle.license_plate ?? 'this plate';
  }

  get isPrimary(): boolean {
    return this.flow.member?.role === 'primary';
  }
}
